<template>
  <v-dialog
    v-model="dialog"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
    scrollable
  >
    <v-container>
      <transition-group tag="v-row" name="fade-transition">
        <v-col
          v-for="image in cochesImages"
          :key="image.public_id"
          cols="12"
          class="gallery-card"
          md="6"
        >
          <v-hover>
            <template v-slot="{ hover }">
              <v-card
                :img="image.url"
                class="white--text overflow-hidden"
                dark
                height="500"
                hover
                @click="select(image.url)"
              >
                <v-fade-transition>
                  <v-overlay v-if="hover" absolute>
                    <v-icon large>
                      mdi-magnify
                    </v-icon>
                  </v-overlay>
                </v-fade-transition>
                <v-slide-y-reverse-transition>
                  <v-footer
                    v-if="hover"
                    absolute
                    class="justify-center"
                    height="75"
                  >
                    <div class="heading">
                      {{ image.filename }}
                    </div>
                  </v-footer>
                </v-slide-y-reverse-transition>
              </v-card>
            </template>
          </v-hover>
        </v-col>
      </transition-group>
    </v-container>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  props: {
    dialog: Boolean,
  },
  computed: {
    ...mapState("cocheNamespace", ["cochesImages"]),
  },
  methods: {
    select(url) {
      this.$emit("select", url);
    },
  },
};
</script>

<style scoped>
.gallery-card {
  transform-origin: center center 0;
  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);
}

.fade-transition-leave,
.fade-transition-leave-active,
.fade-transition-leave-to {
  display: none;
}
</style>
